import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center","width":"100%"} }

import { ref, watchEffect } from 'vue';
import { BaseFormItem, BaseDatePicker, BaseCheckbox } from 'xrk-components';
import { formatter } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'biz-form-times',
  props: /*#__PURE__*/_mergeModels({
    label: { default: '时间' },
    startProp: {},
    endProp: {}
  }, {
    "start": {},
    "startModifiers": {},
    "end": {},
    "endModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(["startChange"], ["update:start", "update:end"]),
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const isLongterm = ref(false);
const startValue = _useModel<string>(__props, 'start');
const endValue = _useModel<string>(__props, 'end');

watchEffect(() => {
  isLongterm.value = endValue.value === '长期';
});

const startDisabledDate = e => {
  // 可选时间不能大于结束时间，结束时间为长期时不限制。
  return endValue.value && endValue.value !== '长期'
    ? new Date(endValue.value).getTime() <
        new Date(formatter.date(e, 'YYYY-MM-DD')).getTime()
    : false;
};
const endDisabledDate = e => {
  // 可选时间不能小于开始时间。
  return startValue.value
    ? new Date(startValue.value).getTime() >
        new Date(formatter.date(e, 'YYYY-MM-DD')).getTime()
    : false;
};
const onLongChange = e => {
  endValue.value = e ? '长期' : '';
};
/** 营业期限起变更，向外抛出供业务计算 isOverSixMonths 等 */
const onStartChange = e => {
  const value = e ? formatter.date(e, 'YYYY-MM-DD') : '';
  emit('startChange', value);
};
const onEndChange = e => {
  console.log(e);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(BaseFormItem), {
      label: `${_ctx.label}起`,
      prop: _ctx.startProp,
      rules: [
      {
        required: true,
        trigger: 'change',
        message: '请选择'
      }
    ]
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseDatePicker), {
          style: {"width":"100%","flex":"none"},
          type: "date",
          placeholder: "请选择",
          "validate-event": true,
          "disabled-date": startDisabledDate,
          onChange: onStartChange,
          modelValue: startValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startValue).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["label", "prop"]),
    _createVNode(_unref(BaseFormItem), {
      label: `${_ctx.label}止`,
      prop: _ctx.endProp,
      rules: [
      {
        required: true,
        trigger: 'change',
        message: '请选择'
      }
    ]
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(BaseDatePicker), {
            style: {"flex":"1"},
            type: "date",
            placeholder: "请选择",
            clearable: false,
            disabled: isLongterm.value,
            "validate-event": true,
            "disabled-date": endDisabledDate,
            onChange: onEndChange,
            modelValue: endValue.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((endValue).value = $event))
          }, null, 8, ["disabled", "modelValue"]),
          _createVNode(_unref(BaseCheckbox), {
            style: {"margin-left":"12px"},
            modelValue: isLongterm.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isLongterm).value = $event)),
            onChange: onLongChange
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 长期有效 ")
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["label", "prop"])
  ], 64))
}
}

})